// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__rmjHq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1pxxp"};